

































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import icon from 'components/presenter/item/ItemIcon'
import SessionItem from 'components/presenter/layout/ActivityDashboardSessionItem.vue'
import ForumTopicItem from 'components/presenter/layout/ActivityDashboardForumTopicItem.vue'
import { ItemType, Session, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    SessionItem,
    ForumTopicItem
  }
})
export default class PresenterLayoutActivityDashboard extends Vue {
  ItemType = ItemType
  icon = icon
  formatDate = date.formatDate
  now = store.now
  state = store.state
  today = new Date()
  sessionsToday: Session[] = []
  sessionsTomorrow: Session[] = []
  sessionsNextDays: Session[] = []
  forumTopics: ForumTopic[] = []

  @Prop()
  readonly load!: () => Promise<{ sessions: Session[], forumTopics: ForumTopic[] }>

  @Prop()
  readonly activitySessionUrl!: (session: Session) => string

  @Prop()
  readonly activityForumTopicUrl!: (forumTopic: ForumTopic) => string

  async refresh (entry: IntersectionObserverEntry) {
    if (entry.isIntersecting) {
      this.today = this.now()
      const todayEnd = date.endOfDate(this.now(), 'day')
      const tomorrowEnd = date.addToDate(todayEnd, { days: 1 })
      this.sessionsToday = []
      this.sessionsTomorrow = []
      this.sessionsNextDays = []
      const { sessions, forumTopics } = await this.load()
      for (const session of sessions) if (session.startedAt) {
        let sessionDate: Date | null = null
        if (new Date(session.startedAt) < this.now()) {
          if (session.stoppedAt) {
            sessionDate = new Date(session.stoppedAt)
          }
        } else  {
          sessionDate = new Date(session.startedAt)
        }
        if (sessionDate) {
          if (sessionDate <= todayEnd) {
            this.sessionsToday.push(session)
          } else if (sessionDate <= tomorrowEnd) {
            this.sessionsTomorrow.push(session)
          } else {
            this.sessionsNextDays.push(session)
          }
        }
      }
      this.forumTopics = forumTopics
    }
  }
}
